export default "__VITE_ASSET__be4ab16b__"